import { debounce } from "lodash";
import { useMemo } from "react";

export const useDebounce = (callback: (props: any) => void, wait = 400) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => debounce(callback, wait), []);
};
